import { render, staticRenderFns } from "./avatarAdmin.vue?vue&type=template&id=ba264300"
import script from "./avatarAdmin.vue?vue&type=script&lang=js"
export * from "./avatarAdmin.vue?vue&type=script&lang=js"
import style0 from "./avatarAdmin.vue?vue&type=style&index=0&id=ba264300&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports